export default __webpack_public_path__ + "static/media/slide_2.b768306d.jpg";